<script setup lang="ts">
// const route = useRoute();
const authStore = useAuthStore();

const isAdmin = ref(false);
const isDemoUser = ref(false);

onMounted(async () => {
  isAdmin.value = await authStore.isAdmin();
  isDemoUser.value = await authStore.isDemoUser();
});

// no-op
</script>

<template>
  <div class="header bg-surface-0">
    <div
      class="bg-surface-0 py-4 px-12 flex items-center justify-between relative lg:static min-h-20 header_inner_wrap">
      <div class="logo flex items-center mr-4 gap-4">
        <nuxt-link :to="{ name: 'index' }">
          <img src="~/assets/images/rs_logo.png" alt="RapidSequence" class="h-12" />
        </nuxt-link>
      </div>

      <a
        v-styleclass="{
          selector: '@next',
          enterFromClass: 'hidden',
          leaveToClass: 'hidden',
          hideOnOutsideClick: true,
        }"
        class="cursor-pointer block lg:hidden text-surface-700">
        <i class="pi pi-bars text-4xl" />
      </a>
      <div
        class="items-center grow justify-between hidden lg:flex absolute lg:static w-full bg-surface-0 left-0 top-full z-10 shadow lg:shadow-none">
        <ul class="list-none p-0 m-0 flex lg:items-center select-none flex-col lg:flex-row">
          <li>
            <nuxt-link
              class="flex px-12 p-4 lg:px-4 lg:py-2 items-center text-surface-600 hover:text-surface-900 hover:bg-surface-100 font-medium rounded-border cursor-pointer transition-colors duration-150"
              :to="{ name: 'index' }"
              active-class="font-bold">
              <i class="pi pi-home mr-2" />
              <span>Home</span>
            </nuxt-link>
          </li>
          <li class="lg:relative">
            <nuxt-link
              :to="{ name: 'modules' }"
              class="flex px-12 p-4 lg:px-4 lg:py-2 items-center text-surface-600 hover:text-surface-900 hover:bg-surface-100 font-medium rounded-border cursor-pointer transition-colors duration-150">
              <i class="pi pi-briefcase mr-2" />
              <span>Modules</span>
            </nuxt-link>
          </li>
          <li v-if="authStore.isAuthenticated && isAdmin">
            <a
              v-styleclass="{
                selector: '@next',
                enterFromClass: 'hidden',
                enterActiveClass: 'animate-scalein',
                leaveToClass: 'hidden',
                leaveActiveClass: 'animate-fadeout',
                hideOnOutsideClick: true,
              }"
              :to="{ name: 'admin-modules' }"
              class="flex px-12 p-4 lg:px-4 lg:py-2 items-center text-surface-600 hover:text-surface-900 hover:bg-surface-100 transition-colors duration-150 cursor-pointer">
              <i class="pi pi-lock mr-2" />
              <span>Admin</span>
              <i class="pi pi-angle-down ml-auto xl:ml-4" />
            </a>

            <ul
              class="list-none py-0 pl-0 m-0 px-0 py-0 rounded-border shadow-0 shadow absolute hidden origin-top w-50 bg-white cursor-pointer">
              <li>
                <a
                  href="/admin/live-room/"
                  class="flex text-surface-600 p-4 items-center hover:text-surface-900 hover:bg-surface-100 transition-colors duration-150">
                  <i class="pi pi-bolt mr-2" />
                  <span class="font-medium">Live Rooms</span>
                </a>
              </li>

              <li>
                <nuxt-link
                  :to="{ name: 'admin-modules' }"
                  class="flex text-surface-600 p-4 items-center hover:text-surface-900 hover:bg-surface-100 transition-colors duration-150">
                  <i class="pi pi-folder mr-2" />
                  <span class="font-medium">Modules</span>
                </nuxt-link>
              </li>
              <li>
                <nuxt-link
                  :to="{ name: 'admin-cases' }"
                  class="flex text-surface-600 p-4 items-center hover:text-surface-900 hover:bg-surface-100 transition-colors duration-150">
                  <i class="pi pi-file mr-2" />
                  <span class="font-medium">Cases</span>
                </nuxt-link>
              </li>
              <li>
                <nuxt-link
                  :to="{ name: 'admin-case-templates' }"
                  class="flex text-surface-600 p-4 items-center hover:text-surface-900 hover:bg-surface-100 transition-colors duration-150">
                  <i class="pi pi-file-plus mr-2" />
                  <span class="font-medium">Case Templates</span>
                </nuxt-link>
              </li>
              <li>
                <nuxt-link
                  :to="{ name: 'admin-patients' }"
                  class="flex text-surface-600 p-4 items-center hover:text-surface-900 hover:bg-surface-100 transition-colors duration-150">
                  <i class="pi pi-user-plus mr-2" />
                  <span class="font-medium">Patient Templates</span>
                </nuxt-link>
              </li>

              <li>
                <nuxt-link
                  :to="{ name: 'admin-ecommerce' }"
                  class="flex text-surface-600 p-4 items-center hover:text-surface-900 hover:bg-surface-100 transition-colors duration-150">
                  <i class="pi pi-shopping-cart mr-2" />
                  <span class="font-medium">Ecommerce</span>
                </nuxt-link>
              </li>
              <li>
                <nuxt-link
                  :to="{ name: 'stripe' }"
                  class="flex text-surface-600 p-4 items-center hover:text-surface-900 hover:bg-surface-100 transition-colors duration-150">
                  <i class="pi pi-shopping-cart mr-2" />
                  <span class="font-medium">Stripe test</span>
                </nuxt-link>
              </li>
              <li>
                <nuxt-link
                  :to="{ name: 'admin-download-data' }"
                  class="flex text-surface-600 p-4 items-center hover:text-surface-900 hover:bg-surface-100 transition-colors duration-150">
                  <i class="pi pi-download mr-2" />
                  <span class="font-medium">Download Data</span>
                </nuxt-link>
              </li>
            </ul>
          </li>
          <li v-else-if="authStore.isAuthenticated && !isDemoUser">
            <nuxt-link
              :to="{ name: 'live-room' }"
              class="flex text-surface-600 p-4 items-center hover:text-surface-900 hover:bg-surface-100 transition-colors duration-150">
              <i class="pi pi-bolt mr-2" />
              <span class="font-medium">Join Live Room</span>
            </nuxt-link>
          </li>
        </ul>
        <ul
          class="list-none p-0 m-0 flex lg:items-center select-none flex-col lg:flex-row border-t border-surface lg:border-t-0">
          <li v-if="authStore.isAuthenticated">
            <a
              class="flex px-12 p-4 lg:px-4 lg:py-2 items-center text-surface-600 hover:text-surface-900 hover:bg-surface-100 font-medium rounded-border cursor-pointer transition-colors duration-150"
              @click="authStore.logout">
              Logout
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <!-- <ul v-if="route.path !== '/modules'"
    class="breadcrumb_menu list-none py-4 px-8 m-0 bg-surface-0 flex items-center font-medium overflow-x-auto border-t border-black">
    <li class="pr-4">
      <nuxt-link :to="{ name: 'index' }" class="cursor-pointer">
        <i class="pi pi-home text-primary" />
      </nuxt-link>
    </li>
    <template v-if="route.path.startsWith('/modules')">
      <li class="px-2">
        <i class="pi pi-angle-right text-surface-500" />
      </li>
      <li class="px-2">
        <nuxt-link :to="{ name: 'modules' }" class="cursor-pointer text-surface-900 whitespace-nowrap">Modules
        </nuxt-link>
      </li>
    </template>

<template v-if="route.path.startsWith('/admin')">
      <li class="px-2">
        <i class="pi pi-angle-right text-surface-500" />
      </li>
      <li class="px-2">
        <a class="cursor-pointer text-surface-900 whitespace-nowrap">Admin</a>
      </li>
      <template v-if="route.path.startsWith('/admin/modules')">
        <li class="px-2">
          <i class="pi pi-angle-right text-surface-500" />
        </li>
        <li class="px-2">
          <nuxt-link :to="{ name: 'admin-modules' }" class="cursor-pointer text-surface-900 whitespace-nowrap">Modules
          </nuxt-link>
        </li>
      </template>
<template v-else-if="route.path.startsWith('/admin/cases')">
        <li class="px-2">
          <i class="pi pi-angle-right text-surface-500" />
        </li>
        <li class="px-2">
          <nuxt-link :to="{ name: 'admin-cases' }"
            class="cursor-pointer text-surface-900 whitespace-nowrap">Cases</nuxt-link>
        </li>
      </template>
<template v-else-if="route.path.startsWith('/admin/case-templates')">
        <li class="px-2">
          <i class="pi pi-angle-right text-surface-500" />
        </li>
        <li class="px-2">
          <nuxt-link :to="{ name: 'admin-case-templates' }"
            class="cursor-pointer text-surface-900 whitespace-nowrap">Case Templates</nuxt-link>
        </li>
      </template>

<template v-else-if="route.path.startsWith('/admin/ecommerce')">
        <li class="px-2">
          <i class="pi pi-angle-right text-surface-500" />
        </li>
        <li class="px-2">
          <nuxt-link :to="{ name: 'admin-ecommerce' }"
            class="cursor-pointer text-surface-900 whitespace-nowrap">Ecommerce</nuxt-link>
        </li>
      </template>

<template v-else-if="route.path.startsWith('/admin/users')">
        <li class="px-2">
          <i class="pi pi-angle-right text-surface-500" />
        </li>
        <li class="px-2">
          <nuxt-link :to="{ name: 'admin-ecommerce' }"
            class="cursor-pointer text-surface-900 whitespace-nowrap">Ecommerce</nuxt-link>
        </li>
        <li class="px-2">
          <i class="pi pi-angle-right text-surface-500" />
        </li>
        <li class="px-2">User Access</li>
      </template>
</template>
</ul> -->
</template>
